"use client"; // Error boundaries must be Client Components

import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useEffect } from "react";
import { toast } from "sonner";
import { getInitialInvoiceData } from "../constants";
import { ErrorMessage } from "@/components/etc/error-message";
import {
  METADATA_LOCAL_STORAGE_KEY,
  PDF_DATA_LOCAL_STORAGE_KEY,
} from "@/app/schema";
import { DEFAULT_METADATA } from "@/app/(app)/utils/get-app-metadata";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    toast.error("משהו השתבש! אנא נסה לרענן את הדף.", {
      id: "app-error-toast",
      closeButton: true,
    });
  }, [error]);

  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-4">
        <ErrorMessage>
          משהו השתבש.
          <br /> אנא נסה לרענן את הדף או להשתמש בדפדפן Chrome.
        </ErrorMessage>
        <ErrorMessage>
          ניתן גם לנסות לאפס את נתוני החשבונית למטה ולמלא אותם מחדש. <br /> אם
          הבעיה נמשכת, נסה לנקות את האחסון המקומי של הדפדפן שלך באופן ידני.
        </ErrorMessage>
        <Button
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => {
              reset();
            }
          }
          variant="outline"
        >
          נסה שוב
        </Button>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button> אפס נתוני חשבונית והתחל מחדש</Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle> האם אתה בטוח?</AlertDialogTitle>
              <AlertDialogDescription>
                פעולה זו תאפס לצמיתות את נתוני החשבונית. יהיה עליך למלא אותם
                מחדש. פעולה זו אינה ניתנת לביטול.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>ביטול</AlertDialogCancel>
              <AlertDialogAction
                onClick={() => {
                  try {
                    localStorage.setItem(
                      PDF_DATA_LOCAL_STORAGE_KEY,
                      JSON.stringify(getInitialInvoiceData()),
                    );

                    localStorage.setItem(
                      METADATA_LOCAL_STORAGE_KEY,
                      JSON.stringify(DEFAULT_METADATA),
                    );

                    reset();

                    toast.success("נתוני החשבונית נוקו", {
                      id: "app-error-toast-clear-invoice-data-success",
                      closeButton: true,
                    });
                  } catch (error) {
                    console.error(error);

                    toast.error("שגיאה בניקוי נתוני החשבונית", {
                      id: "app-error-toast-clear-invoice-data",
                      closeButton: true,
                    });
                  }
                }}
              >
                אפס נתוני חשבונית
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
}
